<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de precio APL cupon</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <router-link
              :to="{
                path: '/cat/cupones-apl/crear',
                params: {},
              }"
              class="btn btn-success btn-md"
            >
              <i class="fas fa-plus"></i>
              Asignar nuevo cupon APL
            </router-link>
            <CambiarTipoTareaModalComponent @refreshData="filterData()" />
            <div class="col-sm-12">
              <br />
              <div class="form-inline justify-content-sm-end">
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Nombre o descripción"
                  v-model="filter.searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.tipo_oferta"
                  @change="filterData()"
                >
                  <option value>TIPO OFERTA</option>
                  <option value="I">INTERNO</option>
                  <option value="E">EXTERNO</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <CuponesAplTableComponent :dataTabla="dataTabla" />
      </div>
      <PaginationComponent
        :currentPage="currentPage"
        :data="dataTabla"
        @pagechanged="filterData"
      />
    </div>
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import CuponesAplTableComponent from "@/components/cat/cupones_apl/CuponesAplTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import CambiarTipoTareaModalComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CambiarTipoTareaModalComponent";

export default {
  components: {
    CuponesAplTableComponent,
    UsuariosSelectComponent,
    CategoriaSelectComponent,
    SubCategoriaSelectComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
    CambiarTipoTareaModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      dataTabla: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        proveedor: "",
        fecha: "",
        categoria: "",
        subcategoria: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.filterData();
  },
  methods: {
    ModalCambiarTipoTarea() {
      let self = this;
      $("#cambiarTipoTareaGlobal").modal("show");
    },
    filterData(page) {
      let self = this;
      if (!page) {
        page = 1;
      }
      self.currentPage = page;
      DynamicService.fetch("cat", "lista-precio-cupon", {
        "filter[search]": self.filter.searchtext,
        tipo_oferta: self.filter.tipo_oferta,
        page: page,
      }).then((response) => {
        self.dataTabla = response.data;
      });
    },
    clearFilterData() {
      this.$data.currentPage = 1;
      this.filter.searchtext = "";
      this.filter.tipo_oferta = "";
      DynamicService.fetch("cat", "lista-precio-cupon").then((response) => {
        this.dataTabla = response.data;
      });
    },
  },
};
</script>
